
import React from 'react';
import { useNavigate } from 'react-router-dom';
import SuperAdminLayout from '@/components/superadmin/SuperAdminLayout';
import SuperAdminSettingsTabs from '@/components/admin/SuperAdminSettingsTabs';
import SuperAdminSettingsHeader from '@/components/superadmin/SuperAdminSettingsHeader';
import { useSuperAdminSettings } from '@/hooks/useSuperAdminSettings';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const SuperAdminSettings = () => {
  const navigate = useNavigate();
  const {
    isLoading,
    activeTab,
    setActiveTab,
    user,
    handleLogout,
    handleSaveSettings
  } = useSuperAdminSettings();

  return (
    <SuperAdminLayout
      isLoading={isLoading}
      onLogout={handleLogout}
      userRole={user?.role}
      activeTab="settings"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/super-admin/dashboard')}
          className="mb-4"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Dashboard
        </Button>
        
        <div className="flex flex-col items-start mb-6">
          <SuperAdminSettingsHeader />
          {user?.role && (
            <span className="mt-2 px-3 py-1 text-xs font-semibold text-white rounded-full bg-purple-600">
              {user.role.charAt(0).toUpperCase() + user.role.slice(1)}
            </span>
          )}
        </div>
        
        <SuperAdminSettingsTabs 
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          onSaveSettings={handleSaveSettings}
        />
      </div>
    </SuperAdminLayout>
  );
};

export default SuperAdminSettings;
